export default {
  assetScope: {
    title: '资产使用规则',
    ruleTab: '使用规则',
    defaultTab: '默认策略',
    recycleTab: '回收站',
    addRule: '添加门店资产使用规则',
    ruleName: '规则名称',
    shopName: '门店名称',
    groupName: '门店组名称',
    targetName: '适用门店',
    matchType: '使用方式',
    matchShop: '仅资产产生门店',
    matchGroup: '指定门店组',
    useType: '使用方式',
    isUsed: '使用状态',
    used: '已使用',
    unused: '未使用',
    createTime: '创建时间',
    deleteTime: '删除时间',
    action: '操作',
    view: '查看',
    edit: '编辑',
    delete: '删除',
    restore: '恢复',
    permanentDelete: '彻底删除',
    addTitle: '添加资产使用规则',
    basicInfo: '基础信息',
    usageSection: '使用方式',
    usageHelpTitle: '资产生效说明',
    usageHelpDescription: '会员资产使用时实时查询当前使用规则列表，不按资产产生时间区分历史资产和新增资产。',
    usageHelpOrderTitle: '实时判断顺序',
    usageHelpOrderDescription: '命中手动规则时按使用方式限制范围；未命中时按默认策略页签当前配置处理。回收站规则不参与查询。',
    editTitle: '编辑资产使用规则',
    viewTitle: '查看资产使用规则',
    deleteTitle: '删除资产使用规则',
    deleteRuleTitle: '删除{ruleName}',
    deleteConfirmTitle: '确认删除规则',
    deleteRuleLabel: '规则：{ruleName}',
    deleteMoveNotice: '删除后，该规则从使用规则列表移入回收站。',
    deleteRecycleInactive: '回收站规则不参与实时使用判断',
    deleteImpactNotice: '本次调整会影响相关门店来源的存量资产和新增资产可用范围，请确认后操作。',
    deleteUsageNotice: '会员使用资产时只查询使用规则列表；未命中手动规则时按默认策略页签当前配置处理。',
    deleteRestorable: '可在回收站恢复',
    deleteConfirmAction: '确认删除',
    confirmDelete: '确定要将该资产使用规则移入回收站吗？',
    confirmRestore: '确定要恢复该资产使用规则吗？',
    restoreRuleTitle: '恢复{ruleName}',
    restoreConfirmTitle: '确认恢复规则',
    restoreUsageNotice: '恢复后，该规则重新进入使用规则列表，并参与会员资产使用时的实时查询。',
    restoreAvailabilityNotice: '覆盖对象未被使用规则占用时，可以恢复。',
    restoreRecycleNotice: '恢复后回收站中不保留该记录',
    restoreConfirmAction: '确认恢复',
    ruleNamePlaceholder: '请输入规则名称',
    targetPlaceholder: '请选择覆盖对象',
    shopScopeHint: '该门店产生的会员资产仅可在本门店使用：{name}',
    groupScopeHint: '该门店组内产生的会员资产仅可在本门店组内使用：{name}',
    selectShopFirst: '请先选择门店',
    selectGroupFirst: '请先选择门店组',
    overridesDefaultPolicy: '覆盖默认策略',
    remark: '备注',
    remarkPlaceholder: '请输入备注',
    save: '保存',
    confirm: '确认',
    select: '选择',
    selectShop: '选择门店',
    applicableShops: '适用门店',
    shopSelectionTip: '门店名单保存后固定，新增门店不会自动加入。',
    selectedShopCount: '已选 {count} 家',
    sourceShopOnly: '仅资产产生门店可用',
    sourceShopOnlyTip: '开启后，资产仅可在产生门店使用；关闭后，所选门店之间可互通使用。',
    enabled: '开启',
    disabled: '关闭',
    effectNoticeTitle: '生效说明',
    effectNoticeDescription: '规则实时影响所选门店产生的已有资产和新增资产。未配置规则的门店按照默认策略处理。',
    shopRequired: '请选择至少一家适用门店',
    shopCountLabel: '已选 {count} 家门店',
    selectedShopsShare: '所选门店互通',
    selectShopGroup: '选择门店组',
    searchName: '搜索名称或城市',
    selected: '已选择',
    shopCode: '门店编码',
    shopStatus: '门店状态',
    shopEnabled: '启用',
    shopDisabled: '停用',
    shopPending: '待开业',
    shopPlanned: '计划开业',
    shopOperating: '开业中',
    shopSuspended: '暂停营业',
    shopClosed: '永久关闭',
    region: '区域',
    city: '城市',
    ruleOccupancy: '规则占用',
    usageAvailable: '可设置使用规则',
    usageOccupied: '已有使用规则',
    usageSelected: '已被当前规则选择',
    shopCount: '门店数',
    coveredShopCount: '覆盖门店数',
    shopUnit: '家',
    occupied: '已被其他规则占用',
    defaultTitle: '未配置门店默认策略',
    ruleDefaultPolicyHint: '会员资产使用时实时查询使用规则列表；命中手动规则按手动规则处理，未命中时按默认策略页签当前配置处理。',
    defaultDescription: '仅在资产产生门店未命中手动使用规则时生效；切换后实时影响相关门店来源的存量资产和新增资产。',
    policyRule: '未配置门店池内可用',
    policyRuleDesc: '未配置手动规则的门店形成动态门店池，池内门店产生的会员资产仅可在池内互通。',
    policyRuleScenario: '适合默认互通，但不能影响已手动配置规则门店的场景。',
    policyTenant: '全部门店可用',
    policyTenantDesc: '未配置手动规则的门店产生的会员资产，可在全部门店使用。',
    policyTenantScenario: '适合总部强管控、会员资产天然全域通用的场景。',
    policySource: '仅来源门店可用',
    policySourceDesc: '未配置手动规则的门店产生的会员资产，只能在资产产生门店使用。',
    policySourceScenario: '适合默认强隔离、每家门店先只允许使用本店资产的场景。',
    policyMostPermissive: '最宽松',
    policyMostRestrictive: '最严格',
    policyRecommended: '推荐',
    policyCurrent: '当前使用',
    saveDefault: '保存并实时生效',
    switchDefaultTitle: '切换默认策略',
    switchDefaultConfirmTitle: '确认切换默认策略',
    currentDefaultPolicy: '当前默认使用方式',
    nextDefaultPolicy: '切换后默认使用方式',
    switchEffective: '本次调整会影响',
    switchEffectiveNow: '实时生效',
    manualRulePriority: '手动规则优先；已回收规则不参与判断。',
    manualRulePriorityDesc: '仅影响未命中手动规则的资产',
    switchDefaultNotice: '本次调整会影响未手动配置规则门店的存量资产和新增资产可用范围，请确认后操作。',
    confirmSwitch: '确认切换',
    loadFailed: '加载失败',
    selectRequired: '请选择覆盖对象',
    nameRequired: '请输入规则名称',
    removeSuccess: '已移入回收站',
    restoreSuccess: '恢复成功',
    saveSuccess: '保存成功',
    switchSuccess: '默认策略已切换',
    noPermanentDelete: '暂未提供彻底删除接口',
    shop: '门店',
    group: '门店组',
  },
};
